import React, { useState, useEffect, useRef } from 'react';
import { Menu, MenuItem, FormControl, IconButton } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { getDateOperators } from '../../list.functions';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs'
import DateBetweenFilterElement from './DateBetweenFilterElement';
import DateAfterBeforeFilterElement from './DateAfterBeforeFilterElement';

const DateFilter = ({ item, applyValue }) => {
    const prevOperator = useRef('between')
    const [operator, setOperator] = useState(item?.operator || prevOperator.current);
    const [value, setValue] = useState(item?.value || '');
    const [focused, setFocused] = useState(false);
    const { t } = useTranslation();
    const operatorList = getDateOperators(t)

    const handleValueChange = (value) => {
        setValue(value);
        applyValue({ ...item, operator: operator, value: value })
    };

    const handleOperatorChange = (operator) => {
        setOperator(operator);
        handleClose();
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (!operator || operator == prevOperator.current) return;

        prevOperator.current = operator;
        
        if (['after', 'before'].includes(operator) && value?.from) {
            handleValueChange(value?.from);
        } else if (['after', 'before'].includes(operator) && typeof value === 'string') {
            handleValueChange(value);
        } else if (operator == 'between' && typeof value === 'string') {
            handleValueChange({from:value, to:dayjs().format('YYYY-MM-DD')});
        } else if (operator == 'between' && typeof value === 'object') {
            handleValueChange(value);
        }
    }, [operator]);

    return (
        <FormControl variant="standard" size="small" className='mtska-list-filter-wrapper'>
            {
                ['between'].includes(operator) && <DateBetweenFilterElement operator={operator} value={value} handleValueChange={handleValueChange} setFocused={setFocused} />
            }
            {
                ['after', 'before'].includes(operator) && <DateAfterBeforeFilterElement operator={operator} value={value} handleValueChange={handleValueChange} setFocused={setFocused} />
            }

            <IconButton
                size="small"
                onClick={handleOpen}
            >
                <FilterListIcon fontSize="small" />
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {operatorList.map((operator) => (
                    <MenuItem
                        key={operator.value}
                        value={operator.value}
                        onClick={() => handleOperatorChange(operator.value)}
                    >
                        {operator.label}
                    </MenuItem>
                ))}
            </Menu>
        </FormControl>
    );
};

export default DateFilter;
